import { FinalEvaluation, FinalEvaluationResponse, Proyecto } from "./projectService";
import { fetchAuthSession } from 'aws-amplify/auth';
import { postJson } from "./httpClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const questionService = {
    crearEvaluacion: async (proyecto: Proyecto): Promise<Evaluation> => {
        try {
            const sesion = await fetchAuthSession();
            const token = sesion.tokens?.idToken;
            const data = await postJson<CreateEvaluationResponse>(`${API_BASE_URL}/create-evaluation`, proyecto, {
                "Authorization": `Bearer ${token}`,
            });
            return data.evaluation ?? {} as Evaluation;
        } catch (error) { 
            console.error("Error al crear evaluación:", error);
            throw error;
        }
    },
    guardarEvaluacion: async (answers: EvaluationAnswer): Promise<boolean>=>{
        try {
            const sesion = await fetchAuthSession();
            const token = sesion.tokens?.idToken;
            const data = await postJson<SaveEvaluationResponse>(`${API_BASE_URL}/evaluation/save-answers`, answers, {
                "Authorization": `Bearer ${token}`,
            });
            return data.status??false;
        } catch (error) { 
            console.error("Error al guardar evaluación:", error);
            throw error;
        }
    },
    finalizarEvaluacion: async (evaluacion: Evaluation): Promise<FinalEvaluationResponse>=>{
        try {
            const sesion = await fetchAuthSession();
            const token = sesion.tokens?.idToken;
            const data = await postJson<FinalEvaluationResponse>(`${API_BASE_URL}/evaluation/close`, evaluacion, {
                "Authorization": `Bearer ${token}`,
            });
            return data;
        } catch (error) { 
            console.error("Error al guardar evaluación:", error);
            throw error;
        }
    }
};

export interface CreateEvaluationResponse {
    message: string;
    error?: string;
    evaluation?: Evaluation;
}
export interface SaveEvaluationResponse {
    message: string;
    error?: string;
    status?: boolean;
}
export interface CloseEvaluationResponse {
    message: string;
    error?: string;
    status?: boolean;
}
export interface Evaluation {
    id: number;
    idProject: number;
    idProjectType: number;
    fechaEvaluacion: Date|null;
    fechaCreacion: Date|null;
    fechaActualizacion: Date|null;
    rut: string;
    activa:boolean;
    respuestaFinalCrl: string,
    respuestaFinalBrl: string,
    respuestaFinalTrl: string,
    respuestaFinalIprl: string,
    respuestaFinalTmrl: string,
    respuestaFinalFrl: string,
    rls: Rl[];
}

export interface Rl {
    rl: string;
    name:string;
    description:string;
    preguntaFinal:string;
    questions: Level[];
};

export interface Level {
    level: number;
    questionText: string;
    rl0n?:string;
	rl0na?:string;
    rl0nb?:string;
    rl0nc?:string;
    rl0nd?:string;
    answers: Answer[];
};

export interface Answer {
    optionId: number;
    optionText: string;
    answerId: number | null;
    answer: boolean | null;
};

export interface EvaluationAnswer{
    id: number;
    rl: string;
    fechaEvaluacion:Date;
    respuestaFinal:string;
    answers: Answer[];
}
